import { Injectable } from '@angular/core';

import {
  LBSErrorHandler,
  LBSErrorHandlerResult,
} from '../../error-handler/error-handler';
import { LoggingService } from '../../logging/logic/logging.service';
import { ExtFileError } from './ext-file-errors';
import { LBSPdf } from 'plugins/lbs-pdf/src';

@Injectable({
  providedIn: 'root',
})
export class ExtFileErrorErrorHandler implements LBSErrorHandler {
  // Lifecycle
  constructor(private logger: LoggingService) {}

  public async handleError(
    error: Error,
    params?: any,
  ): Promise<LBSErrorHandlerResult> {
    if (Object.values(ExtFileError).includes(error?.message as ExtFileError)) {
      return await this.getErrorHandlerResultForKey(
        error.message as ExtFileError,
        params,
      );
    }
    this.logger.log(
      this.constructor.name,
      'given error',
      error?.message,
      'is not of type ExtFileError',
    );
    return undefined;
  }

  // Private Functions
  public async getErrorHandlerResultForKey(
    error: ExtFileError,
    params?: any,
  ): Promise<LBSErrorHandlerResult> {
    switch (error) {
      case ExtFileError.COULD_NOT_SHARE:
        return {
          alert: {
            title: 'ERROR-HANDLERS.EXTFILE-ERRORS.COULD_NOT_SHARE.TITLE',
            subtitle: 'ERROR-HANDLERS.EXTFILE-ERRORS.COULD_NOT_SHARE.SUBTITLE',
            message: 'ERROR-HANDLERS.EXTFILE-ERRORS.COULD_NOT_SHARE.MESSAGE',
            confirm: 'ERROR-HANDLERS.EXTFILE-ERRORS.COULD_NOT_SHARE.CONFIRM',
            confirmFunc: () => {},
            showExportLog: false,
          },
        };
      case ExtFileError.LOCALFILE_NOT_FOUND_OR_VALID:
        return {
          alert: {
            title:
              'ERROR-HANDLERS.EXTFILE-ERRORS.LOCALFILE_NOT_FOUND_OR_INVALID.TITLE',
            subtitle:
              'ERROR-HANDLERS.EXTFILE-ERRORS.LOCALFILE_NOT_FOUND_OR_INVALID.SUBTITLE',
            message:
              'ERROR-HANDLERS.EXTFILE-ERRORS.LOCALFILE_NOT_FOUND_OR_INVALID.MESSAGE',
            confirm:
              'ERROR-HANDLERS.EXTFILE-ERRORS.LOCALFILE_NOT_FOUND_OR_INVALID.CONFIRM',
            confirmFunc: () => {},
            showExportLog: false,
          },
        };
      case ExtFileError.EXTERNALVIEWERNOTINSTALLED:
        return {
          alert: {
            title:
              'ERROR-HANDLERS.EXTFILE-ERRORS.EXTERNAL_VIEWER_NOT_INSTALLED.TITLE',
            subtitle:
              'ERROR-HANDLERS.EXTFILE-ERRORS.EXTERNAL_VIEWER_NOT_INSTALLED.SUBTITLE',
            message:
              'ERROR-HANDLERS.EXTFILE-ERRORS.EXTERNAL_VIEWER_NOT_INSTALLED.MESSAGE',
            confirm:
              'ERROR-HANDLERS.EXTFILE-ERRORS.EXTERNAL_VIEWER_NOT_INSTALLED.CONFIRM',
            confirmFunc: () => {
              console.log('LBSPDF open store for:', params['packageName']);
              LBSPdf.openStorePage({
                packageName: params['packageName'],
              });
            },
            showExportLog: false,
          },
        };

      default:
        this.logger.error(
          this.constructor.name,
          'Not Handled ExtFileError found!',
          error,
        );
        return undefined;
    }
  }
}
